export default "__VITE_ASSET__81c8b591__"